"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notifyEventProcessors = notifyEventProcessors;

var _debugBuild = require("./debug-build.js");

var _is = require("./utils-hoist/is.js");

var _logger = require("./utils-hoist/logger.js");

var _syncpromise = require("./utils-hoist/syncpromise.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */
function notifyEventProcessors(processors, event, hint, index = 0) {
  return new _syncpromise.SyncPromise((resolve, reject) => {
    const processor = processors[index];

    if (event === null || typeof processor !== 'function') {
      resolve(event);
    } else {
      const result = processor(_objectSpread({}, event), hint);
      _debugBuild.DEBUG_BUILD && processor.id && result === null && _logger.logger.log(`Event processor "${processor.id}" dropped event`);

      if ((0, _is.isThenable)(result)) {
        void result.then(final => notifyEventProcessors(processors, final, hint, index + 1).then(resolve)).then(null, reject);
      } else {
        void notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
      }
    }
  });
}